import React from 'react'

export const Stamp: React.FC = () => {
  return (
    <path d="M1 15.9998H15V13.9998H1V15.9998ZM13 7.99983H10.92C10.4119 7.99983 10 7.58796 10 7.07983V6.78421C10 5.92889 10.2775 5.11514 10.6706 4.35545C10.9553 3.80514 11.0738 3.15576 10.9534 2.46732C10.7419 1.25545 9.75125 0.257943 8.53906 0.0470053C6.64437 -0.282683 5 1.16638 5 2.99982C5 3.44232 5.0975 3.86045 5.27156 4.2367C5.68813 5.13827 6 6.0842 6 7.07764V7.07983C6 7.58796 5.58812 7.99983 5.08 7.99983H3C1.34312 7.99983 0 9.34296 0 10.9998V11.9998C0 12.552 0.447812 12.9998 1 12.9998H15C15.5522 12.9998 16 12.552 16 11.9998V10.9998C16 9.34296 14.6569 7.99983 13 7.99983Z" />
  )
}

export default Stamp
